import React from "react";

import { Grid } from "@material-ui/core";

import InputLookupControllingArea from "../../../accounting/lookups/controllingArea";
import InputLookupChartAccounts from "../../../accounting/lookups/chartAccounts";

export default function FilesConvertSiengiTotvs({ attr, setAttr }) {
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <InputLookupChartAccounts
                        label="Plano de Contas"
                        value={attr.chart_account}
                        onChangeValue={(data) => {
                            if (!data) {
                                setAttr({
                                    ...attr,
                                    branch: {},
                                });
                            } else {
                                setAttr({
                                    ...attr,
                                    chart_account: {
                                        id: data.id,
                                        name: data.name,
                                    },
                                });
                            }
                        }}
                        required={true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputLookupControllingArea
                        label="Àrea de Controladoria"
                        value={attr.controlling_area}
                        onChangeValue={(data) => {
                            if (!data) {
                                setAttr({
                                    ...attr,
                                    branch: {},
                                });
                            } else {
                                setAttr({
                                    ...attr,
                                    controlling_area: {
                                        id: data.id,
                                        name: data.name,
                                    },
                                });
                            }
                        }}
                        required={true}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export function FilesConvertSiengiTotvsValidade(data) {
    const message = [];

    if (!data?.chart_account?.id) {
        message.push("Informe o plano de contas para geração.");
    }

    if (!data?.controlling_area?.id) {
        message.push("Informe a área de controladoria para geração.");
    }

    return {
        status: message.length === 0,
        data: {
            chart_account_id: data?.chart_account.id,
            controlling_area_id: data?.controlling_area.id,
        },
        message,
    };
}
